module.exports = __webpack_public_path__ + "img/check.2e70aa1.svg";